








































































































































































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import Program from '../models/Program';
import { formatProgramTaxSystem } from '@/data/programs';
import { BACKEND_URL } from '@/helpers/constants';
import Lightbox from '@/components/Lightbox.vue';
import { formatProgramStateStatus } from '@/data/programStateStatus';
import { getTaxSystemValue } from '@/data/taxSystems';

@Component({
    components: {
        Lightbox,
    },
    filters: {
        formatProgramStateStatus,
        formatTaxSystem: (value: string[]) => {
            let state = '';
            value.forEach(el => {
                if(value.indexOf(el) !== 0) {
                    state += ', '
                }
                state += getTaxSystemValue(el);
            });
            return state;
        },
    },
})
export default class ProgramInfos extends Vue {
    @Prop() program!: Program;
    imageModal: string | null = null;
    BACKEND_URL = BACKEND_URL;
    
    
    commissionRate: number = 0;
    withHono: boolean = false;



    created() {
            this.loadCommissionRateFromAuth();
        }



    get formatProgramTaxSystem(): typeof formatProgramTaxSystem {
        return formatProgramTaxSystem;
    }

    get rearMargin(): number | null {
  const promoter = this.program && this.program.promoter;
  if (!promoter || promoter.rear_margin === null || promoter.rear_margin === undefined) {
    return null;
  }
  const value = parseFloat(promoter.rear_margin);
  return isNaN(value) ? null : value;
}

get dutyFreeFeeDisplay(): string {
  if (!this.program) {
    return 'NC';
  }

  const fee = this.program.duty_free_fee;

  if (fee == null || isNaN(fee)) {
    return 'NC';
  }

  return `${fee.toFixed(2)} %`;
}


get rearMarginDisplay(): string {
  if (!this.program || !this.program.promoter) {
    return 'NC';
  }

  const margin = this.program.promoter.rear_margin;

  if (margin == null) {
    return 'NC';
  }

  if (margin === 'to_determine') {
    return 'À déterminer';
  }

  const parsed = parseFloat(margin);
  if (isNaN(parsed)) {
    return 'NC';
  }

  return `${(parsed * 100).toFixed(2)} %`;
}




     loadCommissionRateFromAuth() {
                        const raw = localStorage.getItem('auth');
                        
                        if (!raw) return;

                        try {
                        const auth = JSON.parse(raw);
                        const subs = Array.isArray(auth.subscriptions) ? auth.subscriptions : [];
                        if (subs.length === 0) return;
                        const last = subs[subs.length - 1];

                        console.log('[Auth] last.with_hono =', last.with_hono,
                                    ', last.commission_rate =', last.commission_rate);

                        this.withHono = !!last.with_hono;
                        this.commissionRate = typeof last.commission_rate === 'string'
                            ? parseFloat(last.commission_rate)
                            : Number(last.commission_rate) || 0;

                        console.log('[Auth] this.withHono =', this.withHono,
                                    ', this.commissionRate =', this.commissionRate);
                        } catch (e) {
                        console.error('[Auth] JSON.parse error:', e);
                        }
                    }

                    get netHono(): number {
                        const base = Number(this.program.duty_free_fee) || 0;
                        const net = base - this.commissionRate;
                        // on n’affiche jamais un négatif
                        return net > 0 ? Math.round(net * 100) / 100 : 0;
                    }



    get programeImage(): undefined | null | string {
        if (!this.program) {
            return undefined;
        }

        if (!this.program.primary_perspective) {
            return null;
        }

        return `${BACKEND_URL}${this.program.primary_perspective.url}${
            this.program.primary_perspective.name
        }.${this.program.primary_perspective.extension}`;
    }

    get programDutyFreeFee() {
        if (!this.program) {
            return undefined;
        }

        if (this.program.promoter.is_multi_fee === 'yes') {
            return this.program.promoter.duty_free_fee;
        } else if (this.program.promoter.is_multi_fee === 'no') {
            return this.program.duty_free_fee;
        }

        return undefined;
    }

    commentary (value: string){
            if(value){
                //@ts-ignore
                if(value.matchAll(/[\r\n]+/g)){
                    //@ts-ignore
                    return value.replaceAll(/[\r\n|\r|\n]{1,1}/g, '<br>');
                }
            }
    }

    get mandat() {
        if (!this.program) {
            return undefined;
        }

        if (this.program.promoter.is_multi_mandat === 'yes') {
            return this.program.promoter.mandat;
        } else if (this.program.promoter.is_multi_mandat === 'no') {
            return this.program.mandat;
        }

        return undefined;
    }

    addBr(value: string) {
        return value.replace(/(?:\r\n|\r|\n)/g, '<br />');
    }
    isManageable() {
        if(this.program && this.program.tax_system) {
            if (this.program.tax_system.includes('LMNP VEFA Divers') ||
                this.program.tax_system.includes('LMNP Étudiant') ||
                this.program.tax_system.includes('LMNP Senior') ||
                this.program.tax_system.includes('LMNP Tourisme') ||
                this.program.tax_system.includes('LMNP EHPAD') ||
                this.program.tax_system.includes('LMNP Coliving') ||
                this.program.tax_system.includes('LMNP Colocation') ||
                this.program.tax_system.includes('LMNP CRT') ||
                this.program.tax_system.includes('CIIC Corse') ||
                this.program.tax_system.includes('Revente LMNP') ||
                this.program.tax_system.includes('Revente Étudiant') ||
                this.program.tax_system.includes('Revente Sénior') ||
                this.program.tax_system.includes('Revente Rés') ||
                this.program.tax_system.includes('Revente EHPAD') ||
                this.program.tax_system.includes('Revente LMNP Tourisme') ||
                this.program.tax_system.includes('Revente fin défiscalisation')) {
                return true;
            }
        }
        return false;
    }
    get isLMNP() {
        if(this.program && this.program.tax_system) {
            if (
                this.program.tax_system.includes('LMNP VEFA Divers') ||
                this.program.tax_system.includes('LMNP Étudiant') ||
                this.program.tax_system.includes('LMNP Senior') ||
                this.program.tax_system.includes('LMNP Tourisme') ||
                this.program.tax_system.includes('LMNP EHPAD') ||
                this.program.tax_system.includes('LMNP Coliving') ||
                this.program.tax_system.includes('LMNP Colocation') ||
                this.program.tax_system.includes('LMNP CRT') ||
                this.program.tax_system.includes('CIIC Corse')
            ) {
                return true;
            }
        }
        return false;
    }
}
